export default __webpack_public_path__ + "static/media/launchrock.dfa7052e.svg";